(() => {
  const messages = document.getElementById('qc-quick-cart-config');
  const nativeConfig = document.getElementById('cart-config');
  const ajax = window.Shopify?.theme?.ajaxCart;
  if (!messages || !nativeConfig || !ajax) return;
  const labels = JSON.parse(messages.textContent);
  const config = JSON.parse(nativeConfig.textContent);
  const root = window.Shopify.routes.root;
  const drawer = document.getElementById('slideout-ajax-cart');
  let currentCart = null;
  let busy = false;
  let revision = 0;
  let closeTimer = null;
  const ruleCache = new WeakMap();
  const announce = document.createElement('p');
  announce.className = 'visually-hidden';
  announce.setAttribute('role', 'status');
  document.body.append(announce);

  const text = (button, value) => {
    if (button.tagName === 'INPUT') button.value = value;
    else (button.querySelector('[data-qp-button-label]') || button).textContent = value;
  };
  const cartCount = id => (currentCart?.items || []).reduce((total, item) => total + (String(item.variant_id) === String(id) ? item.quantity : 0), 0);
  const cancelClose = () => { clearTimeout(closeTimer); closeTimer = null; };
  const nativeShow = ajax.showDrawer;
  ajax.showDrawer = function(...args) { cancelClose(); return nativeShow.apply(this, args); };
  const nativeHide = ajax.hideDrawer;
  ajax.hideDrawer = function(...args) { cancelClose(); return nativeHide.apply(this, args); };

  function openAfterAdd() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    ajax.showDrawer(config);
    closeTimer = setTimeout(() => {
      closeTimer = null;
      if (!busy) ajax.hideDrawer(config);
    }, 10000);
  }

  function rules(form) {
    const source = form?.querySelector('[data-qc-rules]');
    if (!source) return null;
    if (!ruleCache.has(source)) {
      try { ruleCache.set(source, JSON.parse(source.textContent)); }
      catch { return null; }
    }
    return ruleCache.get(source);
  }

  function state(form) {
    const data = rules(form);
    if (!data) return null;
    const id = form.elements.namedItem('id')?.value;
    const rule = data.variants[id];
    if (!rule) return null;
    const count = cartCount(id);
    const step = Math.max(1, Number(rule.step) || 1);
    const min = Math.max(1, Number(rule.min) || 1);
    const max = rule.max == null ? Infinity : Math.max(0, Number(rule.max));
    const minAdd = Math.max(min, (Math.floor(count / step) + 1) * step) - count;
    const maxAdd = Number.isFinite(max) ? Math.floor(max / step) * step - count : Infinity;
    return {data, id, rule, count, step, min, max, minAdd, maxAdd, single: max === 1};
  }

  function errorFor(form, message) {
    let error = form.querySelector('.qc-quick-error');
    if (!error) {
      error = document.createElement('p');
      error.className = 'qc-quick-error';
      error.setAttribute('role', 'alert');
      form.append(error);
    }
    error.textContent = message || '';
    error.hidden = !message;
  }

  function syncForm(form, reset = false) {
    const s = state(form);
    if (!s) return;
    const button = form.querySelector('[data-qc-buy]');
    const input = form.elements.namedItem('quantity');
    if (!button || !input) return;
    const changed = form.dataset.qcSelected !== s.id;
    form.dataset.qcSelected = s.id;
    const limited = s.maxAdd < s.minAdd;
    const row = input.closest('[data-qc-quantity-row], .product-qty');
    if (row) {
      row.hidden = s.single;
      row.classList.toggle('qc-single-quantity', s.single);
    }
    input.min = s.minAdd;
    input.step = s.step;
    if (Number.isFinite(s.maxAdd)) input.max = Math.max(0, s.maxAdd);
    else input.removeAttribute('max');
    let value = Number(input.value);
    if (reset || changed || !Number.isInteger(value) || value < s.minAdd) value = s.minAdd;
    if (!limited && value > s.maxAdd) value = s.maxAdd;
    if (s.single) value = 1;
    input.value = value;
    input.disabled = busy || limited || !s.rule.available;
    if (row) {
      const minus = row.querySelector('[data-qc-step="-1"], .quantity-control-down');
      const plus = row.querySelector('[data-qc-step="1"], .quantity-control-up');
      if (minus) minus.disabled = busy || limited || value <= s.minAdd;
      if (plus) plus.disabled = busy || limited || value + s.step > s.maxAdd;
    }
    const added = s.count > 0;
    const fillValid = syncFilling(form, s, value);
    button.disabled = busy || limited || !s.rule.available || !fillValid;
    button.classList.toggle('qc-is-added', s.single && added);
    const label = s.single && added ? '✓ ' + labels.added : !s.rule.available ? labels.soldOut : limited ? labels.limit : added ? labels.addMore : (form.dataset.qpAdd || labels.add);
    if (button.getAttribute('aria-busy') !== 'true') text(button, label);
    button.setAttribute('aria-label', `${label}: ${s.data.title}`);
    const status = form.querySelector('[data-qc-status]');
    if (status) {
      status.hidden = !added || s.single;
      status.textContent = added ? '✓ ' + labels.inCart.replace('__COUNT__', s.count) : '';
    }
    const note = form.querySelector('[data-qc-rule-note]');
    if (note) {
      note.hidden = s.min === 1 && s.step === 1;
      note.textContent = labels.rules.replace('__MIN__', s.min).replace('__STEP__', s.step);
    }
    const productScope = form.closest('[data-qp-product]');
    if (productScope) {
      const fill = form.querySelector('[data-qc-fill-check]')?.checked ? filling(form) : null;
      form.querySelectorAll('[data-qp-total]').forEach(total => {
        total.textContent = new Intl.NumberFormat(document.documentElement.lang || 'da', {style: 'currency', currency: total.dataset.currency}).format(value * (s.rule.priceCents + (fill ? fill.price * fill.ratio : 0)) / 100);
      });
      const stock = productScope.querySelector('[data-qp-stock]');
      if (stock) stock.textContent = !s.rule.available ? stock.dataset.soldOut : s.rule.stock > 0 ? stock.dataset.count.replace('__COUNT__', s.rule.stock) : stock.dataset.available;
      const sku = productScope.querySelector('[data-qp-sku]');
      if (sku) {
        sku.hidden = !s.rule.sku;
        sku.querySelector('[data-qp-sku-value]').textContent = s.rule.sku || '';
      }
      // A fallback select is used by templates without the native variant block.
      if (changed && form.querySelector('.qp-variant-select')) {
        const price = productScope.querySelector('[data-price]');
        if (price) {
          price.classList.toggle('price--on-sale', Boolean(s.rule.comparePrice));
          price.classList.toggle('price--sold-out', !s.rule.available);
          price.querySelector('.price__regular [data-regular-price]').textContent = s.rule.price;
          price.querySelector('[data-sale-price]').textContent = s.rule.price;
          price.querySelector('.price__sale [data-regular-price]').textContent = s.rule.comparePrice || s.rule.price;
        }
      }
    }
    if (changed && form.classList.contains('b2b-product__form')) {
      const price = form.closest('.b2b-product__details')?.querySelector('.b2b-product__price');
      if (price) {
        const value = document.createElement('span');
        value.textContent = s.rule.price;
        price.replaceChildren(value);
        if (s.rule.comparePrice) {
          const previous = document.createElement('s');
          previous.textContent = s.rule.comparePrice;
          price.append(previous);
        }
      }
    }
  }


  const fillCache = new WeakMap();
  let fillRecovery = false;
  function filling(form) {
    const source = form?.querySelector('[data-qc-fill-data]');
    if (!source) return null;
    if (!fillCache.has(source)) {
      try { fillCache.set(source, JSON.parse(source.textContent)); } catch { return null; }
    }
    return fillCache.get(source);
  }
  function fillAllowed(fill, quantity, existing = cartCount(fill.id)) {
    const total = existing + quantity * fill.ratio;
    return Number.isSafeInteger(quantity) && quantity > 0 && Number.isSafeInteger(fill.ratio) && fill.ratio > 0 && fill.available && total >= fill.min && total % fill.step === 0 && (fill.max == null || total <= fill.max);
  }
  function syncFilling(form, s, quantity) {
    const fill = filling(form);
    if (!fill) return true;
    const panel = form.querySelector('[data-qc-fill]');
    if (!panel) return true;
    const check = panel.querySelector('[data-qc-fill-check]');
    if (!check) return true;
    panel.hidden = false;
    const allowed = fillAllowed(fill, quantity);
    check.disabled = busy || (!allowed && !check.checked);
    panel.classList.toggle('qc-fill--selected', check.checked);
    // A direct checkout cannot include the optional second line. Keep it out of
    // the tab order and accessibility tree while the add-on is selected.
    form.querySelectorAll('.shopify-payment-button, [data-qc-dynamic-payment]').forEach(payment => {
      payment.hidden = check.checked;
      payment.inert = check.checked;
    });
    const checkoutNote = panel.querySelector('[data-qc-fill-checkout-note]');
    if (checkoutNote) checkoutNote.hidden = !check.checked || !form.querySelector('.shopify-payment-button, [data-qc-dynamic-payment]');
    panel.classList.toggle('qc-fill--unavailable', !allowed);
    const format = cents => new Intl.NumberFormat(document.documentElement.lang || 'da', {style:'currency', currency: fill.currency || 'DKK'}).format(cents / 100);
    panel.querySelector('[data-qc-fill-detail]').textContent = labels.fillDetail.replace('__COUNT__', quantity * (fill.unitsPerItem || fill.ratio)).replace('__SIZE__', fill.size);
    panel.querySelector('[data-qc-fill-price]').textContent = '+ ' + format(fill.price * fill.ratio * quantity);
    panel.querySelector('[data-qc-fill-total]').textContent = labels.fillTotal.replace('__PRICE__', format(quantity * (s.rule.priceCents + (check.checked ? fill.price * fill.ratio : 0))));
    const note = panel.querySelector('[data-qc-fill-availability]');
    note.hidden = allowed;
    note.textContent = fill.available ? labels.fillQuantityError : labels.fillUnavailable;
    return !check.checked || allowed;
  }
  const fillChildren = (cart, parent) => cart.items.filter(item => item.properties?._qc_fill_role === 'insert' && item.properties?._qc_fill_group === parent.properties?._qc_fill_group);
  const isFillChild = item => item?.properties?._qc_fill_role === 'insert';
  const isFillParent = item => item?.properties?._qc_fill_role === 'cover';
  async function changeLine(key, quantity) {
    const response = await fetch(root + 'cart/change.js', {method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify({id:key,quantity})});
    const result = await response.json();
    if (!response.ok || result.status >= 400) throw new Error(result.description || labels.error);
    sync(result);
    return result;
  }
  function fillGroupState(cart, group) {
    const parents = cart.items.filter(item => isFillParent(item) && item.properties._qc_fill_group === group);
    const children = cart.items.filter(item => isFillChild(item) && item.properties._qc_fill_group === group);
    if (!children.length) return {parents, children, mismatch:false, split:parents.length > 1};
    const ratio = Number(children[0].properties._qc_fill_ratio);
    const parentKeys = new Set(parents.map(item => item.key));
    const badRelationship = children.some(child => !parentKeys.has(child.parent_relationship?.parent_key));
    const badRatio = !Number.isSafeInteger(ratio) || ratio < 1 || children.some(child => Number(child.properties._qc_fill_ratio) !== ratio);
    const parentTotal = parents.reduce((sum, item) => sum + item.quantity, 0);
    const childTotal = children.reduce((sum, item) => sum + item.quantity, 0);
    return {parents, children, mismatch:!parents.length || badRelationship || badRatio || childTotal !== parentTotal * ratio, split:parents.length !== 1 || children.length !== 1};
  }
  function assertPairedMutation(cart, line) {
    // Never delete a parent whose native cascade would remove a different group.
    // Filling itself remains removable so the customer can recover safely.
    if (isFillChild(line)) return;
    const nativeChildren = cart.items.filter(item => isFillChild(item) && item.parent_relationship?.parent_key === line.key);
    const group = line.properties?._qc_fill_group;
    if (nativeChildren.some(child => !isFillParent(line) || child.properties._qc_fill_group !== group)) throw new Error(labels.fillRepair);
    if (!isFillParent(line)) return;
    const pair = fillGroupState(cart, group);
    if (pair.mismatch) throw new Error(labels.fillRepair);
    if (pair.children.length && pair.split) throw new Error(labels.fillSplit);
  }
  async function changeWithFilling(line, quantity) {
    assertPairedMutation(currentCart, line);
    if (isFillChild(line) && quantity !== 0) throw new Error(labels.fillLinked);
    const children = isFillParent(line) ? fillChildren(currentCart, line) : [];
    if (!children.length || quantity === 0) return changeLine(line.key, quantity);
    const group = line.properties._qc_fill_group;
    const before = children.map(child => ({id:child.variant_id,quantity:child.quantity,ratio:Number(child.properties._qc_fill_ratio) || 1}));
    try {
      for (const child of before) {
        const freshChild = currentCart.items.find(item => isFillChild(item) && item.properties._qc_fill_group === group && item.variant_id === child.id);
        if (freshChild && freshChild.quantity !== quantity * child.ratio) await changeLine(freshChild.key, quantity * child.ratio);
      }
      if (fillGroupState(currentCart, group).split) throw new Error(labels.fillSplit);
      const parent = currentCart.items.find(item => isFillParent(item) && item.properties._qc_fill_group === group);
      if (!parent) throw new Error(labels.fillRepair);
      return await changeLine(parent.key, quantity);
    } catch (failure) {
      await readCart().catch(() => {});
      // Discounts may split lines during the first update. Never guess which
      // split line to roll back; keep checkout guarded until filling is removed.
      if (fillGroupState(currentCart, group).split) throw failure;
      const parent = currentCart.items.find(item => isFillParent(item) && item.properties._qc_fill_group === group);
      if (parent) {
        try {
          for (const child of before) {
            const freshChild = currentCart.items.find(item => isFillChild(item) && item.properties._qc_fill_group === group && item.variant_id === child.id);
            if (freshChild && freshChild.quantity !== parent.quantity * child.ratio) await changeLine(freshChild.key, parent.quantity * child.ratio);
          }
        } catch { fillRecovery = true; }
      }
      throw failure;
    }
  }
  function fillMismatch(cart) {
    const groups = new Set(cart.items.filter(isFillChild).map(item => item.properties._qc_fill_group));
    return [...groups].some(group => fillGroupState(cart, group).mismatch);
  }

  function cartRule(input) {
    return {min: Math.max(1, Number(input.dataset.qcMin) || 1), step: Math.max(1, Number(input.dataset.qcStep) || 1), max: input.dataset.qcMax === '' ? Infinity : Number(input.dataset.qcMax)};
  }

  function syncCartControls() {
    document.querySelectorAll('[data-qc-cart-quantity]').forEach(input => {
      const rule = cartRule(input);
      const line = currentCart?.items.find(item => item.key === input.dataset.itemKey);
      const count = cartCount(input.dataset.itemId);
      const quantity = line?.quantity ?? Number(input.value);
      const other = count - quantity;
      const max = Number.isFinite(rule.max) ? Math.floor(rule.max / rule.step) * rule.step - other : Infinity;
      const min = Math.max(1, rule.min - other);
      input.min = min;
      input.step = rule.step;
      if (Number.isFinite(max)) input.max = max;
      else input.removeAttribute('max');
      input.readOnly = rule.max === 1 || isFillChild(line);
      input.disabled = busy;
      const wrapper = input.closest('.js-item-quantity');
      const plus = wrapper?.querySelector('[data-ajax-qty-increase]');
      const minus = wrapper?.querySelector('[data-ajax-qty-decrease]');
      if (plus) plus.disabled = busy || isFillChild(line) || count + rule.step > rule.max;
      if (minus) minus.disabled = busy || isFillChild(line);
      const row = input.closest('.ajax-cart__cart-item');
      if (row && isFillChild(line) && !row.querySelector('.qc-fill-cart-note')) {
        const note = document.createElement('p');
        note.className = 'qc-fill-cart-note';
        note.textContent = labels.fillLinked;
        row.querySelector('.ajax-cart__item-details')?.append(note);
      }
    });
    document.querySelectorAll('.js-cart-remove').forEach(button => {
      button.setAttribute('role', 'button');
      button.tabIndex = 0;
      button.setAttribute('aria-label', labels.remove);
    });
  }

  function sync(cart) {
    currentCart = cart;
    fillRecovery = fillMismatch(cart);
    document.querySelectorAll('[data-qc-rules]').forEach(source => syncForm(source.closest('form')));
    document.querySelectorAll('.js-cart-count').forEach(count => {
      const value = String(cart.item_count);
      if (count.textContent !== value) count.textContent = value;
      count.classList.toggle('cart-empty', cart.item_count === 0);
    });
    syncCartControls();
  }

  async function readCart() {
    const version = ++revision;
    const response = await fetch(root + 'cart.js', {headers: {Accept: 'application/json'}, cache: 'no-store'});
    if (!response.ok) throw new Error(labels.error);
    const cart = await response.json();
    if (version === revision) sync(cart);
    return cart;
  }

  const updateView = ajax.updateView;
  ajax.updateView = function(settings, cart) {
    ++revision;
    sync(cart);
    return updateView.call(this, settings, cart);
  };

  async function purchase(form) {
    if (busy || !state(form)) return;
    errorFor(form, '');
    const s = state(form);
    const input = form.elements.namedItem('quantity');
    const quantity = Number(input.value);
    const button = form.querySelector('[data-qc-buy]');
    if (!form.reportValidity()) return;
    if (window.theme?.ProductProperties?.checkLineItemProperties && !form.matches('[data-qc-quick-form]') && window.theme.ProductProperties.checkLineItemProperties(form) === false) return;
    const fill = form.querySelector('[data-qc-fill-check]')?.checked ? filling(form) : null;
    let fillGroup = null;
    let addConfirmed = false;
    const payload = new FormData(form);
    payload.set('id', s.id);
    payload.set('quantity', String(quantity));
    payload.delete('button');
    payload.delete('add');
    busy = true;
    cancelClose();
    button.setAttribute('aria-busy', 'true');
    text(button, labels.adding);
    if (currentCart) sync(currentCart);
    try {
      await readCart();
      const fresh = state(form);
      if (!fresh || fresh.id !== s.id) throw new Error(labels.error);
      const total = fresh.count + quantity;
      if (!fresh.rule.available || !Number.isInteger(quantity) || quantity < 1 || total > fresh.max || total < fresh.min || total % fresh.step !== 0) throw new Error(total > fresh.max ? labels.limit : labels.invalidQuantity);
      let request = {method:'POST', headers:{Accept:'application/json'}, body:payload};
      if (fill) {
        if (!fillAllowed(fill, quantity)) throw new Error(labels.fillQuantityError);
        // parent_id identifies a variant, not a particular pre-existing line.
        // Keep same-request association unambiguous; use cart quantity controls
        // for another unit of a cover already present in the cart.
        if (currentCart.items.some(item => String(item.variant_id) === String(s.id))) throw new Error(labels.fillDuplicate);
        fillGroup = crypto.randomUUID();
        // Multipart preserves uploaded line-item properties as well as text,
        // selling plans and the current locale/customer session.
        const bundle = new FormData();
        bundle.set('items[0][id]', s.id);
        bundle.set('items[0][quantity]', String(quantity));
        for (const [key, value] of payload.entries()) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match) bundle.append(`items[0][properties][${match[1]}]`, value);
        }
        bundle.set('items[0][properties][_qc_fill_group]', fillGroup);
        bundle.set('items[0][properties][_qc_fill_role]', 'cover');
        if (payload.get('selling_plan')) bundle.set('items[0][selling_plan]', payload.get('selling_plan'));
        bundle.set('items[1][id]', String(fill.id));
        bundle.set('items[1][quantity]', String(quantity * fill.ratio));
        bundle.set('items[1][parent_id]', s.id);
        bundle.set('items[1][properties][_qc_fill_group]', fillGroup);
        bundle.set('items[1][properties][_qc_fill_role]', 'insert');
        bundle.set('items[1][properties][_qc_fill_ratio]', String(fill.ratio));
        request = {method:'POST', headers:{Accept:'application/json'}, body:bundle};
      }
      const response = await fetch(root + 'cart/add.js', request);
      const result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error(result.description || labels.error);
      addConfirmed = true;
      const cart = await readCart();
      ajax.updateView(config, cart);
      announce.textContent = `${labels.added}: ${fresh.data.title}`;
      openAfterAdd();
    } catch (failure) {
      errorFor(form, failure.message || labels.error);
      await readCart().catch(() => {});
      // Never undo a confirmed add because a subsequent refresh failed.
      if (fillGroup && !addConfirmed) {
        const ownParent = currentCart?.items.find(item => isFillParent(item) && item.properties._qc_fill_group === fillGroup);
        if (ownParent) {
          try {
            assertPairedMutation(currentCart, ownParent);
            await changeLine(ownParent.key, 0);
          } catch { fillRecovery = true; }
        }
        for (const item of currentCart?.items.filter(item => item.properties?._qc_fill_group === fillGroup) || []) {
          await changeLine(item.key, 0).catch(() => { fillRecovery = true; });
        }
      }
      if (currentCart) ajax.updateView(config, currentCart);
    } finally {
      busy = false;
      button.removeAttribute('aria-busy');
      if (currentCart) sync(currentCart);
      else { button.disabled = false; text(button, form.dataset.qpAdd || labels.add); }
    }
  }

  async function changeCart(input, quantity) {
    if (busy || !input) return;
    cancelClose();
    const form = input.closest('form');
    errorFor(form, '');
    const key = input.dataset.itemKey;
    busy = true;
    syncCartControls();
    try {
      await readCart();
      const line = currentCart.items.find(item => item.key === key);
      if (!line) { ajax.updateView(config, currentCart); return; }
      const rule = cartRule(input);
      const other = cartCount(line.variant_id) - line.quantity;
      const total = other + quantity;
      if (!Number.isInteger(quantity) || quantity < 0 || total > rule.max || (total > 0 && (total < rule.min || total % rule.step !== 0))) throw new Error(labels.invalidQuantity);
      const result = await changeWithFilling(line, quantity);
      ajax.updateView(config, result);
    } catch (failure) {
      errorFor(form, failure.message || labels.error);
      const line = currentCart?.items.find(item => item.key === key);
      if (line) input.value = line.quantity;
      if (currentCart) ajax.updateView(config, currentCart);
      errorFor(document.querySelector('.js-cart-form') || form, failure.message || labels.error);
    } finally {
      busy = false;
      if (currentCart) sync(currentCart);
    }
  }

  const stop = event => { event.preventDefault(); event.stopImmediatePropagation(); };
  document.addEventListener('submit', event => {
    if (event.target.matches('.js-cart-form') && (busy || fillRecovery)) {
      stop(event);
      if (fillRecovery) errorFor(event.target, labels.fillRepair);
      return;
    }
    if (!rules(event.target)) return;
    stop(event);
    purchase(event.target);
  }, true);

  document.addEventListener('click', event => {
    const target = event.target.closest('button, input[type="submit"], a, .js-cart-remove');
    if (!target) return;
    if (target.matches('[name="checkout"], .ajax-cart__button-submit, a[href*="/checkout"]') && (busy || fillRecovery)) {
      stop(event);
      if (fillRecovery) errorFor(target.closest('form') || document.querySelector('.js-cart-form'), labels.fillRepair);
      return;
    }
    if (target.closest('.js-mini-cart-trigger, .my-cart-link-container')) cancelClose();
    const payment = target.closest('.shopify-payment-button, [data-qc-dynamic-payment]');
    if (payment?.closest('form')?.querySelector('[data-qc-fill-check]:checked')) {
      stop(event);
      return;
    }
    if (target.matches('[data-qc-buy]')) {
      const form = target.form || target.closest('form');
      if (!state(form)) return;
      stop(event);
      if (!target.disabled) purchase(form);
      return;
    }
    if (target.matches('[data-qc-step], .quantity-control-up, .quantity-control-down')) {
      const row = target.closest('[data-qc-quantity-row], .product-qty');
      const input = row?.querySelector('[name="quantity"]');
      const form = input?.form;
      const s = state(form);
      if (!s) return;
      stop(event);
      if (busy || target.disabled) return;
      const direction = target.matches('[data-qc-step="-1"], .quantity-control-down') ? -1 : 1;
      const value = Number(input.value) + direction * s.step;
      input.value = Math.min(s.maxAdd, Math.max(s.minAdd, value));
      syncForm(form);
      return;
    }
    if (target.matches('[data-ajax-qty-increase], [data-ajax-qty-decrease], .js-cart-remove')) {
      const row = target.closest('.ajax-cart__cart-item');
      const input = row?.querySelector('[data-qc-cart-quantity]');
      if (!input) return;
      stop(event);
      if (busy || target.disabled) return;
      const rule = cartRule(input);
      let quantity = Number(input.value);
      if (target.matches('.js-cart-remove')) quantity = 0;
      else if (target.matches('[data-ajax-qty-increase]')) quantity += rule.step;
      else quantity = quantity - rule.step < Number(input.min) ? 0 : quantity - rule.step;
      changeCart(input, quantity);
    }
  }, true);

  document.addEventListener('change', event => {
    const input = event.target;
    if (input.matches('[data-qc-cart-quantity]')) {
      stop(event);
      changeCart(input, Number(input.value));
      return;
    }
    const form = input.form;
    if (rules(form)) {
      if (input.matches('[data-qc-fill-check]')) {
        errorFor(form, '');
        syncForm(form);
      } else if (input.name === 'id') {
        errorFor(form, '');
        syncForm(form, true);
      } else if (input.name === 'quantity') {
        event.stopImmediatePropagation();
        syncForm(form);
      }
    }
  }, true);

  document.addEventListener('keydown', event => {
    if (event.target.matches('.js-cart-remove') && ['Enter', ' '].includes(event.key)) {
      event.preventDefault();
      event.target.click();
    }
  });

  if (drawer) {
    drawer.setAttribute('aria-label', document.querySelector('#mini-cart h2')?.textContent.trim() || labels.added);
    const close = drawer.querySelector('.slideout__trigger-ajax-cart');
    if (close) close.setAttribute('aria-label', labels.close);
    for (const name of ['pointerdown', 'pointermove', 'keydown', 'wheel', 'touchstart', 'input', 'change']) drawer.addEventListener(name, cancelClose, {passive: true});
    drawer.addEventListener('toggle', event => { if (event.newState === 'closed') cancelClose(); });
    const keepShopping = document.createElement('button');
    keepShopping.type = 'button';
    keepShopping.className = 'qc-continue-shopping';
    keepShopping.textContent = labels.continue;
    keepShopping.addEventListener('click', () => ajax.hideDrawer(config));
    drawer.querySelector('#mini-cart')?.append(keepShopping);
  }
  document.querySelectorAll('.js-ajax-cart-content').forEach(content => {
    new MutationObserver(syncCartControls).observe(content, {childList: true, subtree: true});
  });
  document.querySelectorAll('[data-qc-rules]').forEach(source => syncForm(source.closest('form')));
  readCart().catch(() => {});
  window.addEventListener('pageshow', () => readCart().catch(() => {}));
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) cancelClose();
    else if (!busy) readCart().catch(() => {});
  });
  document.addEventListener('shopify:section:load', () => { if (currentCart) sync(currentCart); });
})();



